import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { rel } from '../utils/rel';
import auth, { LoginDialog } from '@ifeng-fe/ui_pc_auth';

class UserInfo extends React.PureComponent {
    static propTypes = {
        iconShow: PropTypes.bool,
        isIE78: PropTypes.bool,
        option: PropTypes.array,
    };

    static defaultProps = {
        iconShow: false,
        option: ['register', 'login'],
    };

    state = {
        isShow: false,
        userInfo: auth.isLogin() ? auth.getUserInfo() : null,
    };

    loginId = auth.uuid();

    componentDidMount() {
        this.unBindLogin = auth.event.on(auth.EVENTNAMES.login, userInfo => {
            this.setState({
                userInfo,
            });
        });
        this.unBindLogout = auth.event.on(auth.EVENTNAMES.logout, () => {
            this.setState({
                userInfo: null,
            });
        });
    }

    componentWillUnmount() {
        this.unBindLogin();
        this.unBindLogout();
    }

    handleLoginIn = () => {
        auth.login(this.loginId);
    };

    handleLoginOut = () => {
        auth.logout();
    };

    handleOptionList = () => {
        const { isShow } = this.state;

        this.setState({ isShow: !isShow });
    };

    /**
     * 渲染组件
     */
    render() {
        const { isShow, userInfo } = this.state;
        const { iconShow, isIE78, option } = this.props;
        const isLogin = auth.isLogin();

        const iconOptions = {
            register: (
                <span key="register" className={isIE78 ? styles.register : styles.register_2x}>
                    <span />
                    <a href="https://user.ifeng.com/register/" target="_blank" rel={rel}>
                        注册
                    </a>
                </span>
            ),
            login: (
                <span
                    key="login"
                    className={isIE78 ? styles.login_in : styles.login_in_2x}
                    onClick={this.handleLoginIn}>
                    <em />
                    登录
                </span>
            ),
        };

        const options = {
            register: (
                <span key="register" className={styles.register}>
                    <a href="https://user.ifeng.com/register/" target="_blank" rel={rel}>
                        注册
                    </a>
                </span>
            ),
            login: (
                <span key="login" className={styles.login_in} onClick={this.handleLoginIn}>
                    登录
                </span>
            ),
        };

        let login = '';

        if (isLogin) {
            login = (
                <div className={styles.login_after}>
                    {iconShow ? (
                        <div className={isIE78 ? styles.welcome : styles.welcome_2x}>
                            <span />欢迎您
                        </div>
                    ) : (
                        ''
                    )}
                    <div className={styles.login_info} onClick={this.handleOptionList}>
                        <span className={isIE78 ? styles.login_name : styles.login_name_2x}>
                            <span>{userInfo.userName}</span>
                            <em />
                        </span>
                        {isShow ? (
                            <ul className={styles.options}>
                                <li>
                                    <a href="//user.ifeng.com/security" target="_blank" rel={rel}>
                                        进入个人中心
                                    </a>
                                </li>
                                {/* <li>
                                    <a href="//zmt.ifeng.com/" target="_blank" rel={rel}>
                                        进入我的大风号
                                    </a>
                                </li> */}
                            </ul>
                        ) : (
                            ''
                        )}
                    </div>
                    <div className={styles.login_out} onClick={this.handleLoginOut}>
                        退出
                    </div>
                </div>
            );
        } else {
            login = (
                <div className={styles.login}>
                    {option.map(item => (iconShow ? iconOptions[item] : options[item]))}
                    <LoginDialog id={this.loginId} />
                </div>
            );
        }

        return login;
    }
}

export { UserInfo };
export default UserInfo;
